export enum RecordOriginCode {
  Eld = 1,
  Driver = 2,
  Other = 3,
  UnidentifiedDriver = 4,
}
